(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-extras"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var tooltipButtons = document.querySelectorAll('.open-tooltip');
    var allTooltips = document.querySelectorAll('.tooltip-container [role="tooltip"]');

    var hideAllTooltips = function() {
      allTooltips.forEach(function(item) {
        item.classList.add('visually-hidden');
      });
    };

    tooltipButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var tooltipId = button.getAttribute('aria-describedby');
        var tooltip = document.getElementById(tooltipId);
        if (tooltip) {
          var isHidden = tooltip.classList.contains('visually-hidden');
          hideAllTooltips();
          tooltipButtons.forEach(function(btn) {
            btn.setAttribute('aria-expanded', 'false');
          });
          if (isHidden) {
            tooltip.classList.remove('visually-hidden');
            button.setAttribute('aria-expanded', 'true');
          }
        }
      });
      document.addEventListener('click', function(event) {
        if (!button.contains(event.target)) {
          var tooltipId = button.getAttribute('aria-describedby');
          var tooltip = document.getElementById(tooltipId);
          if (tooltip) {
            tooltip.classList.add('visually-hidden');
            button.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
